import { SVGProps } from 'react'

const ConnectIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M11.6666 9.998C11.6666 7.92158 9.73579 5.83333 7.38091 5.83333C7.10197 5.83333 6.18249 5.83334 5.95234 5.83334C3.58541 5.83334 1.66663 7.69793 1.66663 9.998C1.66663 11.98 3.0914 13.6387 4.99996 14.0595C5.30626 14.1271 5.62501 14.1627 5.95234 14.1627'
                stroke='white'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.33337 9.998C8.33337 12.0744 10.2642 14.1627 12.6191 14.1627C12.898 14.1627 13.8175 14.1627 14.0476 14.1627C16.4146 14.1627 18.3334 12.2981 18.3334 9.998C18.3334 8.016 16.9086 6.35737 15 5.93652C14.6937 5.86898 14.375 5.83332 14.0476 5.83332'
                stroke='white'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ConnectIcon
